import { render, staticRenderFns } from "./Koutu_Price_3dlivewall2022.vue?vue&type=template&id=7519e212&scoped=true"
import script from "./Koutu_Price_3dlivewall2022.vue?vue&type=script&lang=js"
export * from "./Koutu_Price_3dlivewall2022.vue?vue&type=script&lang=js"
import style0 from "./Koutu_Price_3dlivewall2022.vue?vue&type=style&index=0&id=7519e212&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7519e212",
  null
  
)

export default component.exports